import { render } from "./SmallHeaderBarFields.vue?vue&type=template&id=2a1ce7b5"
import script from "./SmallHeaderBarFields.vue?vue&type=script&lang=js"
export * from "./SmallHeaderBarFields.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__